<template>
    <v-dialog v-model="show" @click:outside="$emit('update:show', false)" max-width="600">
        <v-card>
            <v-toolbar color="primary" dark flat>
                <v-toolbar-title class="text-capitalize">delivery methods</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="subtitle-1 mt-3">
                <h4 class="mb-3">We have four (4) delivery methods available at Kaoshi</h4>
                <p> <span class="font-weight-bold">Bank Deposit</span> - This delivery method indicates that the recipient of the money transfer will receive the money in a bank account.</p>
                <p> <span class="font-weight-bold">Mobile Money</span> - This delivery method indicates that the recipient of the money transfer will receive the money in a mobile money account.</p>
                <p> <span class="font-weight-bold">Cash Pick-Up</span> - This delivery method indicates that the recipient of the money transfer will receive the money in cash at the office of the money transfer company or its agents.</p>
                <p> <span class="font-weight-bold">Cash Delivery</span> - This delivery method indicates that the money will be delivered to the recipient at his home.</p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        show: Boolean,
    },
}
</script>

<style>

</style>